import axios from '../utils/axiosClient';
import endpoints from './endpoints';
import { StatementHistoriesParams, StatementHistoriesResponse } from '../interfaces/statement';

const { getStatementHistories, downloadStatementHistory } = endpoints;

const loadStatementHistories = async (params: StatementHistoriesParams): Promise<StatementHistoriesResponse> => {
  try {
    const response = await axios.get(getStatementHistories, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const saveStatementFile = (fileUrl: string, fileName: string) => {
  const link = document.createElement('a');

  link.href = fileUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const fetchStatementFile = async (id: string) => {
  try {
    const response = await axios.get(downloadStatementHistory(id), { responseType: 'blob' });
    const fileBlob = new Blob([response.data], { type: response.headers['content-type'] });
    return URL.createObjectURL(fileBlob);
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const downloadStatement = async (id: string, fileName: string) => {
  const fileUrl = await fetchStatementFile(id);

  saveStatementFile(fileUrl, fileName);
  URL.revokeObjectURL(fileUrl);
};

const statementsService = {
  loadStatementHistories,
  downloadStatement,
  fetchStatementFile,
  saveStatementFile,
};

export default statementsService;
